// src/pages/TestRouter.jsx
import React, { useEffect, useState } from "react";
import { ref, get, update, set } from "firebase/database";
import { db } from "../services/firebase";
import { useNavigate } from "react-router-dom";

export default function TestRouter() {
  const navigate = useNavigate();
  const session = JSON.parse(localStorage.getItem("studentSession"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const routeTest = async () => {
      if (!session?.specialStudentId) {
        navigate("/student-login");
        return;
      }

      const studentRef = ref(db, `studentAttempts/${session.specialStudentId}`);
      const snap = await get(studentRef);

      if (!snap.exists()) {
        navigate("/expired");
        return;
      }

      let data = snap.val();
      const now = Date.now();

      // ✅ Get testId from student attempt or use DEFAULT
      const testId = data.testId || session.testId || "DEFAULT";

      // ❌ Already submitted
      if (data.status === "submitted") {
        navigate("/expired");
        return;
      }

      // ✅ First time start - initialize attempt
      if (!data.startedAt) {
        data.startedAt = now;
        data.status = "in_progress";
        await update(studentRef, {
          startedAt: now,
          status: "in_progress",
          testId
        });
      }

      // Calculate expiry from exam window or default 2 hours
      // Check if there's an exam end time from credentials
      const credRef = ref(db, `studentCredentials/${session.studentId}`);
      const credSnap = await get(credRef);
      let expiresAt = data.startedAt + 2 * 60 * 60 * 1000; // Default 2h

      if (credSnap.exists()) {
        const credData = credSnap.val();
        if (credData.expiresAt) {
          expiresAt = credData.expiresAt;
        } else if (credData.endTime) {
          expiresAt = new Date(credData.endTime).getTime();
        }
      }

      if (now > expiresAt) {
        await update(studentRef, { status: "expired" });
        navigate("/expired");
        return;
      }

      // Save activeTest with testId
      localStorage.setItem(
        "activeTest",
        JSON.stringify({
          ...data,
          testId, // DEFAULT or teacher's test ID
          startedAt: data.startedAt,
          expiresAt,
          specialStudentId: session.specialStudentId,
          loginId: session.studentId,
        })
      );

      // Navigate to VidyaPariksha (unified test component)
      navigate("/exam"); // ← This will load VidyaPariksha
    };

    routeTest().finally(() => setLoading(false));
  }, [navigate, session]);

  if (loading) return <p>Preparing your test...</p>;
  return null;
}
